/*
 * @Description: 审核当条数据
 * @Date: 2021-10-28 18:10:31
 */

import auditNoPass from './audit-no-pass.js';
import { MessageBox, Notification } from 'element-ui';
import { taskRecordListAll } from '@R/api';

/**
 * @description: 单条记录审核
 * @param {function} ajax 请求方法
 * @param {function} beforeGetList 点击确认 ，准备调接口之前
 * @param {function} afterGetList 取消或者接口请求完毕调用
 * @param {object} params 请求参数
 * @param {number} auditStatus 审核状态
 * @param {function} getList 父级列表方法
 * @param {number} auditLength 审核条数
 * @return {promise} Promise.resolve(pdata)
 */
export default async function({
  ajax,
  params = {},
  auditStatus,
  beforeGetList = () => {},
  afterGetList = () => {},
  getList,
  auditLength,
  cleanAllSelectedAjax = taskRecordListAll
}) {
  const { projectId } = params;
  let notificationMessage = '操作成功';
  try {
    // 通过
    if (+auditStatus === 2) {
      await MessageBox.confirm(
        `<p>是否确认通过${
          auditLength
            ? `<span style="color:#027cfa">${auditLength}</span>条`
            : ''
        }任务记录，请谨慎操作</p>`,
        {
          dangerouslyUseHTMLString: true
        }
      );
      notificationMessage = '通过成功';
      beforeGetList();
    }
    // 不通过
    if (+auditStatus === 3) {
      const rejectResp = await auditNoPass(auditLength);
      params.remarkType = rejectResp.type;
      params.remark = rejectResp.remark;
      notificationMessage = '不通过成功';
      beforeGetList();
    }
  } catch (err) {
    // return Promise.reject(err);
    return;
  }

  const { pdata } = await ajax(params);
  Notification({
    message: notificationMessage,
    type: 'success'
  });
  await cleanAllSelectedAjax({
    projectId,
    isSelected: '0',
    conditions: []
  });
  getList && (await getList());
  afterGetList();
  return Promise.resolve(pdata);
}
